import React, { useMemo, useState } from 'react';
import CapacityPlanningSummaryCards from '../components/CapacityPlanningSummaryCards';
import CapacityPlanningFilterBar from '../components/CapacityPlanningFilterBar';
import ExpansionCandidatePanel from '../components/ExpansionCandidatePanel';
import ExpansionCandidateTable from '../components/ExpansionCandidateTable';
import CapacityPressurePanel from '../components/CapacityPressurePanel';
import DemandPressurePanel from '../components/DemandPressurePanel';
import RevenueOpportunityPanel from '../components/RevenueOpportunityPanel';
import RecommendationDrawer from '../components/RecommendationDrawer';
import { useCapacityPlanningData } from '../hooks/useCapacityPlanningData';
import { AppShell, PageContainer } from '../../ui-system';

const CapacityPlanningPage = () => {
  const { summary, candidates, topCandidates, filters, isLoading, error, refetch } = useCapacityPlanningData();
  const [selected, setSelected] = useState(null);

  const pressureItems = useMemo(() => candidates || [], [candidates]);

  return (
    <AppShell>
      <PageContainer>
      <div className="w-full space-y-4">
      <div>
        <h1 className="text-xl font-semibold text-slate-100">Smart Capacity Planning & Expansion Planner</h1>
        <p className="text-sm text-slate-400">Prioritas ekspansi berbasis tekanan kapasitas, demand, risiko layanan, dan peluang pendapatan.</p>
      </div>

      <CapacityPlanningSummaryCards summary={summary} />
      <CapacityPlanningFilterBar filters={filters} onRefresh={refetch} />

      {isLoading ? <div className="rounded-lg border border-slate-800 bg-slate-900/70 p-4 text-sm text-slate-300">Memuat data capacity planning...</div> : null}
      {error ? <div className="rounded-lg border border-red-900 bg-red-950/40 p-4 text-sm text-red-300">Gagal memuat data: {String(error.message || error)}</div> : null}

      <ExpansionCandidatePanel items={topCandidates} onOpenDetail={setSelected} />
      <ExpansionCandidateTable items={candidates} onOpenDetail={setSelected} />

      <div className="grid gap-4 xl:grid-cols-3">
        <CapacityPressurePanel items={pressureItems} />
        <DemandPressurePanel items={pressureItems} />
        <RevenueOpportunityPanel items={pressureItems} />
      </div>

      <RecommendationDrawer item={selected} open={Boolean(selected)} onClose={() => setSelected(null)} />
      </div>
      </PageContainer>
    </AppShell>
  );
};

export default CapacityPlanningPage;
